export type Keyword = {
  text: string;
  colorClass: string;
  tag: string;
};

export const supportedIndicatorTypes = [
  "Generic Greeting",
  "Urgent/Threatening Language",
  "Spelling/Grammar Errors",
  "Requests for PII",
  "Unexpected Reward",
  "Unrealistic Offer",
  "Brand Impersonation",
  "Request for Financial Assistance",
] as const;

export type IndicatorTypeSupported = (typeof supportedIndicatorTypes)[number];

export type ThreatCoachIndicator = {
  title: string;
  type: IndicatorTypeSupported;
  staticDescription: string;
  keywords: string[];
  colorClass: string;
  tag: string;
};

export const isIndicatorSupportedType = (
  string: string,
): string is IndicatorTypeSupported =>
  supportedIndicatorTypes.includes(string as IndicatorTypeSupported);
